import React, { isValidElement } from 'react';
import I18N from '@leverege/i18n';
import { Flex } from '@leverege/ui-elements';
const {
  t
} = I18N.ns('temporaryUserManagement.ResourceTemporaryUsersScreen.noDataView');
export default function NoDataView({
  label = 'No Data'
}) {
  return /*#__PURE__*/React.createElement(Flex, {
    style: {
      width: '100%',
      height: '100%'
    },
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/isValidElement(label) ? label : t('noData', label)));
}